<div [style.height]="!!height ? height + 'vh' : '100%'" class="comments">
  <div class="d-flex align-items-center">
    <textarea
      id="newCommentTextarea"
      rows="2"
      autocomplete="off"
      placeholder="Write your comment ..."
      [disabled]="isEditing || readonly"
      [(ngModel)]="newComment"
      class="flex-grow-1 form-control scroll"
      (input)="onCommentPosted()"
      (keypress)="pressKeyPost($event)"
      (focus)="editingEventPlayed.emit(true)"
      (focusin)="$event.stopPropagation()"
      (focusout)="editingEventPlayed.emit(false)"
      [perfectScrollbar]="{ wheelPropagation: false }"
    ></textarea>
    <div *ngIf="quickComments.length > 0" class="dropdown dropdown-inline dropleft h-100">
      <button
        type="button"
        data-toggle="dropdown"
        matTooltip="Quick Comments"
        class="btn-comment btn btn-light-dark"
      >
        <span inlineSVG="assets/media/svg/icons/Communication/Chat1.svg" class="svg-icon"></span>
      </button>
      <div class="dropdown-menu quick-comments-table">
        <table>
          <tr>
            <th>Code</th>
            <th>Comment</th>
          </tr>
          <tr
            *ngFor="let comment of quickComments"
            class="quick-comment-item"
            (click)="addNewCode(comment)"
          >
            <td>{{ comment.code }}</td>
            <td>{{ comment.comment }}</td>
          </tr>
        </table>
      </div>
    </div>
    <button
      [disabled]="newComment.trim().length == 0"
      type="button"
      matTooltip="Post Comment"
      class="btn-comment btn btn-light-dark"
      (click)="postComment(newComment.trim()); newComment = ''"
    >
      <span
        *ngIf="!isSubmittingComment"
        inlineSVG="assets/media/svg/icons/Communication/Chat6.svg"
        class="svg-icon"
      ></span>
      <span *ngIf="isSubmittingComment" class="spinner-border spinner-border-md"></span>
    </button>
  </div>
  <div class="flex-grow-1 comments-view scroll" [perfectScrollbar]="{ wheelPropagation: false }">
    <div *ngIf="!!comments?.length" class="p-15px">
      <div
        *ngIf="(type === 'TASK' || type === 'WORKFLOW') && seeAllShow"
        class="btn btn-link"
        (click)="seeAllComments()"
      >
        {{ getSeeWord() }}
      </div>
      <div *ngFor="let c of sortByDate(comments)" class="d-flex align-items-start mb-15px">
        <kt-user-photo [size]="34" [editable]="false" [type]="'object'" [user$]="c"></kt-user-photo>
        <div class="flex-grow-1 bg-white rounded ml-15px">
          <div class="d-flex align-items-center justify-content-between bb-light px-15px py-2">
            <div>
              <span class="text-muted font-size-xs mr-1">
                <span *ngIf="!!c.updated" class="mr-1">{{
                  c.updated + ' UTC' | date : 'MMM dd, hh:mm a'
                }}</span
                >by
              </span>
              <span class="text-dark-50 font-size-sm font-weight-bolder">
                {{ c.last_modified_user }}
              </span>
            </div>
            <div *ngIf="c.last_modified_user === currentUser?.userName">
              <ng-container *ngIf="!c.editMode && !readonly">
                <ng-template ngxPermissionsOnly="canEditComments">
                  <button
                    type="button"
                    matTooltip="Edit"
                    class="btn btn-sm btn-icon btn-white"
                    (click)="editCommentValue = c.comment; c.editMode = true; isEditing = true"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                      class="svg-icon svg-icon-sm svg-icon-light"
                    ></span>
                  </button>
                </ng-template>
                <ng-template ngxPermissionsOnly="canDeleteComments">
                  <button
                    type="button"
                    matTooltip="Delete"
                    class="btn btn-sm btn-icon btn-white"
                    (click)="deleteComment(c)"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                      class="svg-icon svg-icon-sm svg-icon-light"
                    ></span>
                  </button>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="c.editMode && !readonly">
                <div
                  *ngIf="quickComments.length > 0"
                  class="dropdown dropdown-inline dropleft h-100"
                >
                  <button
                    type="button"
                    data-toggle="dropdown"
                    matTooltip="Quick Comments"
                    class="btn btn-sm btn-icon btn-white"
                  >
                    <span
                      inlineSVG="assets/media/svg/icons/Communication/Chat1.svg"
                      class="svg-icon svg-icon-sm svg-icon-light"
                    ></span>
                  </button>
                  <div class="dropdown-menu quick-comments-table">
                    <table>
                      <tr>
                        <th>Code</th>
                        <th>Comment</th>
                      </tr>
                      <tr
                        *ngFor="let comment of quickComments"
                        class="quick-comment-item"
                        (click)="addCodeToUpdate(comment)"
                      >
                        <td>{{ comment.code }}</td>
                        <td>{{ comment.comment }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <button
                  type="button"
                  matTooltip="Save"
                  [disabled]="editCommentValue.trim().length == 0"
                  class="btn btn-sm btn-icon btn-white"
                  (click)="updateComment(c)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Navigation/Check.svg"
                    class="svg-icon svg-icon-sm svg-icon-light"
                  ></span>
                </button>
                <button
                  type="button"
                  matTooltip="Cancel"
                  class="btn btn-sm btn-icon btn-white"
                  (click)="c.editMode = false; isEditing = false"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
                    class="svg-icon svg-icon-sm svg-icon-light"
                  ></span>
                </button>
              </ng-container>
            </div>
          </div>
          <pre *ngIf="!c.editMode" class="long-text-wrap text-dark-75 font-size-sm p-15px">{{
            c.comment
          }}</pre>
          <textarea
            *ngIf="c.editMode && !readonly"
            rows="4"
            autocomplete="off"
            [(ngModel)]="editCommentValue"
            style="border: none !important"
            class="form-control scroll"
            (input)="onCommentUpdated()"
            (keypress)="pressKey($event, c)"
            (focus)="editingEventPlayed.emit(true)"
            (focusin)="$event.stopPropagation()"
            (focusout)="editingEventPlayed.emit(false)"
            [perfectScrollbar]="{ wheelPropagation: false }"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
